import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { Topic } from '@/types';

import { useAskBluejApiContext } from '../api/context';

type OrganizationAccessTopic = {
  topics: Topic[];
}

export function useOrganizationAccessTopicsQuery(): UseQueryResult<OrganizationAccessTopic> {
  const { api } = useAskBluejApiContext();

  return useQuery({
    queryKey: ['organization-access-topics'],
    queryFn: async () => {
      return await api.getTopics();
    },
    staleTime: Infinity,
    gcTime: Infinity
  });
}
